<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.location.list") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.master')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/master/location"><span>{{$t('tlt.location')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('location')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.code") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="codeFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.name") }} :
                                    </label>
                                    <input class="form-control" type="text" v-model="locNameFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.type") }} :
                                    </label>
                                    <select class="form-control" v-model="locTypeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="E">{{ $t("lbl.location.enterprise") }}</option>
                                        <option value="S">{{ $t("lbl.location.site") }}</option>  
                                        <option value="A">{{ $t("lbl.location.area") }}</option>                                        
                                        <option value="W">{{ $t("lbl.location.workCenter") }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.location.childOf") }}:
                                    </label>
                                    <select class="form-control"  v-model="childOfFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option v-for="child in childs" 
                                        :value="child.id" :key=child.id>{{child.locName}}</option>
                                    </select>
                                </div>
                                <!-- <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.active") }}:
                                    </label>
                                    <select class="form-control"  v-model="activeFilter">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                </div> -->
                                <div class="col-lg-4 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('location')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('location')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="locationResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="location" inline-actions-disabled singleChoice>
                                <div slot="btnList" class="btn-group">
                                    <button v-bind:class="'btn btn-outline-primary btn-sm'" v-on:click="jumpToLocationTree()">
                                        <i class="fas fa-tasks"></i>
                                        <span class="text">{{$t('lbl.location.tree')}}</span>
                                    </button>
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/master/Location";
import MmfTable from "@/components/MmfTable";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'location/getField',
    mutationType: 'location/updateField',
});

export default {
  name: "locationList",
  data () {
    return {
      checkedItems: []
    }
  },
  components: { MmfTable },
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            rows: state => state.location.rows,
            tableColumns: gridFields,
            childs: state => state.location.childs,
            locationList: state => state.location.locationList
        })
  },
  methods: {

    ...mapActions("location", ["loadChildOf"]),
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"]),
    getLocationTree(dataArr,locationParent) {
        var arr = [];
        for(var i = 0; i < dataArr.length; i++) {
            var node = dataArr[i];
            // console.log(node);
            // console.log(node.locationParent);
            if(node.locationParent == locationParent) {
                var newNode;
                var child = this.getLocationTree(dataArr,node.id);
                if(child) {
                    newNode = {name:node.locName,children:child};
                }
                else{
                    newNode = {name:node.locName};
                }
                // console.log(newNode);
                arr.push(newNode);
            }
        }
        return arr;
    },
    jumpToLocationTree() {
        let dataArr = this.locationList;
        console.log(dataArr);
        let locationList = this.getLocationTree(dataArr,null);
        console.log(locationList);
        this.$router.push({
            path: "/master/location/tree",
            query: {
                locationModel: locationList[0]
            }
        });
    }
  },
  mounted(){
      this.$store.dispatch('location/loadChildOf');
      this.$store.dispatch('location/loadLocationList');
  }
};
</script>
